"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormValidator = void 0;
const DOM_1 = require("../DOM");
const M = require("materialize-css");
const PhoneInput_1 = require("../../../../app/controls/Form/components/PhoneInput/PhoneInput");
const Form_1 = require("../../../../app/controls/Form/Form");
const SelectInput_1 = require("../../../../app/controls/Form/components/SelectInput/SelectInput");
const InputValidator_1 = require("./InputValidator");
const SelectValidator_1 = require("./SelectValidator");
const ElementValidatorUtil_1 = require("./ElementValidatorUtil");
const FormValidatorUtil_1 = require("./FormValidatorUtil");
const MultiChooseInput_1 = require("../../../../app/controls/Form/components/MultiChooseInput/MultiChooseInput");
const SalesInfoBoxInput_1 = require("../../../../app/controls/Form/components/SalesInfoBoxInput/SalesInfoBoxInput");
const DateTimePicker_1 = require("../../../../app/controls/Form/components/DateTimePicker/DateTimePicker");
const RatingPicker_1 = require("../../../../app/controls/Form/components/RatingPicker/RatingPicker");
const CheckboxInput_1 = require("../../../../app/controls/Form/components/CheckboxInput/CheckboxInput");
class FormValidator {
    static validateForm(options) {
        M.updateTextFields();
        SelectInput_1.ControlsFormSelectInput.Control.initialize(options.form);
        MultiChooseInput_1.ControlsFormMultiChooseInput.Control.initialize(options.form);
        SalesInfoBoxInput_1.ControlsFormSalesInfoBoxInput.Control.initialize(options.form);
        DateTimePicker_1.ControlsFormDateTimePicker.Control.initialize(options.form);
        CheckboxInput_1.ControlsFormCheckboxInput.Control.initialize(options.form);
        PhoneInput_1.PhoneInput.Control.initialize(options.form);
        RatingPicker_1.ControlsFormRatingPicker.Control.initialize(options.form);
        const patternElements = DOM_1.DOM.Parser.getHtmlElementsByQuery('[pattern]', options.form, true);
        for (let index = 0; index < patternElements.length; ++index) {
            patternElements[index].attributes.removeNamedItem('pattern');
        }
        const numberInputs = DOM_1.DOM.Parser.getHtmlElementsByQuery("input[type='number']", options.form, true);
        for (let index = 0; index < numberInputs.length; ++index) {
            const numberInput = numberInputs[index];
            ElementValidatorUtil_1.ElementValidatorUtil.triggerElementValidateNumberOnKey(numberInput);
        }
        const inputs = FormValidatorUtil_1.FormValidatorUtil.getAllInputs(options);
        const submit = FormValidatorUtil_1.FormValidatorUtil.getFormSubmit(options);
        if (FormValidatorUtil_1.FormValidatorUtil.isEditForm(options) && submit) {
            submit.disabled = true;
            options.form.dataset.inputs = options?.forceInputCount?.toString() ?? inputs.length.toString();
        }
        const formDataCurrent = Form_1.ControlsForm.Controller.getFormData(options.form);
        for (let index = 0; index < inputs.length; ++index) {
            const input = inputs[index];
            if (input.type.toLowerCase() === 'submit') {
                input.disabled = true;
            }
            if (input.type.toLowerCase() === 'submit' || input.classList.contains('select-dropdown')) {
                continue;
            }
            if (FormValidatorUtil_1.FormValidatorUtil.isEditForm(options) && !input.hasAttribute('data-current')) {
                input.dataset.current = formDataCurrent[input.name] ?? input.value.trim();
            }
            if (input.dataset.novalidate === 'true') {
                input.dataset.valid = "true";
                continue;
            }
            if (input.tagName.toLowerCase() === "textarea") {
                FormValidator.validateTextareaTrigger(input, options);
            }
            if (input.tagName.toLowerCase() === "select") {
                FormValidator.validateSelectTrigger(inputs[index], options);
            }
            else {
                FormValidator.validateInputTrigger(input, options);
            }
            input.addEventListener("focusin", () => { ElementValidatorUtil_1.ElementValidatorUtil.setElementCanDisplayErrors(input); });
        }
    }
    static validateSelectTrigger(element, options) {
        this.processSelectValidations(element, options);
        element.addEventListener("change", () => { this.processSelectValidations(element, options); });
    }
    static processSelectValidations(element, options) {
        element.dataset.valid = "true";
        const parentElement = element.parentElement;
        if (parentElement?.classList.contains('select-wrapper')) {
            parentElement.dataset.valid = "true";
        }
        element.dataset.problem = "";
        element.dataset.filled = element.value.trim().length > 0 ? 'yes' : 'no';
        SelectValidator_1.SelectValidator.validateSelect(element);
        FormValidatorUtil_1.FormValidatorUtil.updateFormState(options);
    }
    static validateInputTrigger(element, options) {
        this.processValidations(element, null, options);
        ElementValidatorUtil_1.ElementValidatorUtil.initializeShowPasswordButton(element);
        setTimeout(() => { this.processAutoInit(element); }, 500);
        element.addEventListener("countrychange", () => { this.processValidations(element, null, options); });
        element.addEventListener("keyup", () => { this.processValidations(element, null, options); });
        element.addEventListener("change", () => { this.processValidations(element, null, options); });
        element.addEventListener("update", () => { this.processValidations(element, true, options); });
        element.addEventListener("input", () => { this.processValidations(element, true, options); });
    }
    static validateTextareaTrigger(element, options) {
        this.processValidations(element, null, options);
        element.addEventListener("input", () => { this.processValidations(element, null, options); });
        element.addEventListener("change", () => { this.processValidations(element, null, options); });
        element.addEventListener("update", () => { this.processValidations(element, true, options); });
    }
    static processAutoInit(element) {
        if (DOM_1.DOM.Parser.getDataByNameFromElementOrNull('autoActive', element)) {
            if (element.parentElement) {
                const label = DOM_1.DOM.Parser.getElementByTag('label', element.parentElement, true);
                if (label) {
                    label.classList.add('active');
                }
            }
        }
    }
    static processValidations(element, isUpdate, options) {
        element.dataset.valid = "true";
        element.dataset.problem = "";
        element.dataset.filled = element.value.trim().length > 0 ? 'yes' : 'no';
        if (element.disabled) {
            return;
        }
        if (element.classList.contains('PhoneInput-input-input')) {
            PhoneInput_1.PhoneInput.Helpers.validatePhoneInput(element);
        }
        InputValidator_1.InputValidator.validateInput(element, isUpdate, options);
        FormValidatorUtil_1.FormValidatorUtil.updateFormState(options);
        const validCallback = !options.validCallbacks ? null : options.validCallbacks.find((item) => {
            return item.inputName === element.name;
        });
        if (!validCallback) {
            return;
        }
        if (element.dataset.valid.toString() === 'true') {
            validCallback.callback.valid();
        }
        if (element.dataset.valid.toString() === 'false') {
            validCallback.callback.invalid();
        }
    }
}
exports.FormValidator = FormValidator;
